module.exports = __webpack_public_path__ + "img/installiOS3.a041e032.png";